<li [id]="creator.blazeFirebaseUid"
    class="p-2 gap-y-2 cursor-pointer flex flex-col shrink-0 shadow-card-container-pale">
    <cc-creator-column-generic [creator]="creator" [searchColour]="'blue'"></cc-creator-column-generic>

</li>